import { create } from 'zustand';
import * as api from '../lib/api';

interface BillingState {
  pendingCount: number;
  subscription: api.SubscriptionResponse | null;
  usage: api.UsageResponse | null;
  isLoading: boolean;
  fetchBillingInfo: (token: string) => Promise<void>;
  reset: () => void;
}

export const useBillingStore = create<BillingState>((set) => ({
  pendingCount: 0,
  subscription: null,
  usage: null,
  isLoading: false,

  fetchBillingInfo: async (token: string) => {
    set({ isLoading: true });
    try {
      const [sub, usg, payments] = await Promise.all([
        api.getSubscription(token).catch(() => null),
        api.getUsage(token).catch(() => null),
        api.listPayments(token, 50, 'pending').catch(() => ({ data: [] as api.PaymentResponse[] })),
      ]);
      const pending = (payments.data ?? []).length;
      set({ subscription: sub, usage: usg, pendingCount: pending });
    } catch {
      /* non-critical */
    } finally {
      set({ isLoading: false });
    }
  },

  reset: () => set({ pendingCount: 0, subscription: null, usage: null, isLoading: false }),
}));
